


































































































































































































































import { getFormInputMixin } from '@/mixins/formInputMixin';
import { InfeedManagementFormGroup } from '@/types/forms/formGroups/plantData/infeedManagement/infeedManagementFormGroup';
import { InfeedManagementFormGroupContent } from '@/api/interfaces/content/form/steps/plantData/infeedManagementContent';
import FormField from '@/components/molecules/formField/FormField.vue';
import FormTextBlock from '@/components/molecules/formTextBlock/FormTextBlock.vue';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import FormRadioGroup from '@/components/molecules/formRadioGroup/FormRadioGroup.vue';
import DatePicker from '@/components/molecules/datePicker/DatePicker.vue';
import FormBooleanCheckbox from '@/components/molecules/formBooleanCheckbox/FormBooleanCheckbox.vue';

export default getFormInputMixin<
    InfeedManagementFormGroup,
    InfeedManagementFormGroupContent
>().extend({
    name: 'InfeedManagementFormGroup',
    components: {
        FormTextBlock,
        FormField,
        FormRadioGroup,
        FormInputText,
        DatePicker,
        FormBooleanCheckbox,
    },
});
